import { makeStyles } from '@material-ui/core/styles';
import {
  SurfaceColors,
  PrimaryColors,
  SecondaryColors,
  TextColors,
  TextOpacities,
} from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $icon': {
      backgroundColor: SurfaceColors.dark,
      border: `1px solid ${hexToRGBA(TextColors.light, TextOpacities.light3)}`,

      '&, input:hover ~ &, input:disabled ~ &': {
        backgroundColor: SurfaceColors.dark,
      },
    },
    '& $checkedIcon': {
      '&, input:hover ~ &': {
        backgroundColor: SecondaryColors.main,
      },

      '&:before': {
        backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='${hexToRGBA(
          TextColors.dark,
          1,
        )}'/%3E%3C/svg%3E")`,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $icon': {
      backgroundColor: SurfaceColors.light,
      border: `1px solid ${hexToRGBA(TextColors.dark, TextOpacities.dark3)}`,

      '&, input:hover ~ &, input:disabled ~ &': {
        backgroundColor: SurfaceColors.light,
      },
    },
    '& $checkedIcon': {
      '&, input:hover ~ &': {
        backgroundColor: PrimaryColors.main,
      },

      '&:before': {
        backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='${hexToRGBA(
          TextColors.light,
          1,
        )}'/%3E%3C/svg%3E")`,
      },
    },
  },
};

const useStyles = makeStyles(
  () => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& .Mui-focusVisible $icon': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },

      '& $icon, $checkedIcon': {
        borderRadius: 3,
        width: 16,
        height: 16,
        backgroundImage: 'none',

        'input:disabled ~ &': {
          boxShadow: 'none',
          opacity: 0.5,
        },
      },
    },
    icon: {},
    checkedIcon: {
      border: 'none',

      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        content: '""',
      },
    },
  }),
  { name: 'GenStyledCheckbox' },
);

export default useStyles;
